import React, { useEffect, useState } from "react";
import { Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useServerApi } from "../hooks/userServerApi";
import { screenRelatedParty } from "../helpers/screenRelatedParty";
import { DueDiligenceBadge, DueDiligencePanel } from "./clientDueDiligencePanel";

const clientScreenName = (values = {}) => {
  if (values.type === "CORPORATE") {
    return [values.name, values.cname].filter(Boolean).join(" · ");
  }
  const english = [values.surname, values.givenName].filter(Boolean).join(" ");
  return [english, values.cname].filter(Boolean).join(" · ");
};

const ClientDueDiligenceRelatedParty = ({ form }) => {
  const { t } = useTranslation();
  const [api] = useServerApi();
  const [lists, setLists] = useState({ persons: [], corporates: [] });
  const screening = screenRelatedParty(form?.values, lists);
  const name = clientScreenName(form?.values);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const result = await api.search({ apiEntity: "setting", pageSize: 1 });
        if (cancelled) return;
        const setting = result?.docs?.[0] || {};
        setLists({
          persons: setting.fwdRelatedPersons || [],
          corporates: setting.fwdRelatedCorporates || [],
        });
      } catch (loadError) {
        console.log(loadError);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const matched = screening.status === "MATCH";
  const passed = screening.status === "PASS";
  const badge = matched
    ? { color: "orange", label: t("Needs handling") }
    : passed
      ? { color: "green", label: t("Passed") }
      : { color: "gray", label: t("Not ready") };

  const note = matched
    ? t("Request further handling by Operation (match found)")
    : passed
      ? t("Pass (no match found)")
      : t("Enter the client name before screening.");

  return (
    <DueDiligencePanel
      title={t("Related Party")}
      headline={name || null}
      badge={<DueDiligenceBadge color={badge.color}>{badge.label}</DueDiligenceBadge>}
      note={note}
      noteColor={matched ? "orange" : passed ? "green" : "gray"}
    >
      {matched ? (
        <Stack spacing="xs">
          {screening.matches.map((match, index) => (
            <Text key={`${match.englishName}-${match.companyName}-${index}`} size="sm">
              {formatMatch(match)}
            </Text>
          ))}
        </Stack>
      ) : null}
    </DueDiligencePanel>
  );
};

const formatMatch = (match) => {
  if (match.kind === "corporate") {
    return [match.englishName, match.chineseName, match.countryOfIncorporation]
      .filter(Boolean)
      .join(" · ");
  }
  return [match.englishName, match.chineseName, match.companyName, match.companyRole]
    .filter(Boolean)
    .join(" · ");
};

export default ClientDueDiligenceRelatedParty;
